<template>
  <div class="button-wrapper">
    <component :is="tag" :class="buttonClass" v-on="$listeners" :aria-label="label">
      <span class="button__content">
        <slot>{{ label }}</slot>
      </span>
    </component>
    <span class="button-wrapper__error" v-if="error">Please fix {{errorMessage}}</span>
  </div>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    label: String,
    tag: {
      type: String,
      default: 'button'
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    primary: {
      type: Boolean,
      default: false
    },
    primaryterracotta: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    terracotta: {
      type: Boolean,
      default: false
    },
    tertiary: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: '',
    }
  },
  computed: {
    buttonClass () {
      return {
        'button button--primary': this.primary === true,
        'button button--secondary': this.secondary === true,
        'button button--terracotta': this.terracotta === true,
        'button button--tertiary': this.tertiary === true,
        'button button--dark': this.inverse === true,
        'button button--light': this.outline === true,
        'button button--small': this.small === true,
        'button button--large': this.large === true,
        'button button--full': this.full === true,
        'button button--error': this.error === true,
        'button button--primary-terracotta': this.primaryterracotta === true,
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .button__content {
    line-height: 20px;
   
    @include mobile-only {
      line-height: 22px;
    }
  }

  .button-wrapper {
    display: inline-flex;
    flex-direction: column;

    &__error {
      color: $color-util-error;
      text-align: center;
      font-size: rem(10);
      line-height: rem(12);
      padding-top: 5px;
    }
  }
</style>
